<template>
    <!-- 生成二维码 -->
  <div class="qrcode">
    <img v-if="qrCode" class="img-code" :src="qrCode" alt="QR Code" />
  </div>
</template>

<script>
import qrcode from 'qrcode-generator'
export default {
  name: 'QrCode',
  data() {
    return {
      qrCode: null,
    }
  },
  props: {
    qrUrl: { // 生成二维码地址
      type: String,
      required: true,
    },
  },
  mounted() {
    this.generateQRCode()
  },
  methods: {
    generateQRCode() {
      // 创建二维码
      const typeNumber = 8 // QR Code 版本
      const errorCorrectionLevel = 'L' // 错误校正等级，可选 L M Q H
      const qr = qrcode(typeNumber, errorCorrectionLevel)
      qr.addData(`${process.env.baseURL}${this.qrUrl}`)
      qr.make()
      // 获取二维码图片
      this.qrCode = qr.createDataURL(4) // 4 是缩放比例
    },
  },
}
</script>

<style lang='less' scoped>
.qrcode {
  position: relative;
  .img-code {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QrCode.vue